import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inscripcion-home',
  templateUrl: './inscripcion-home.component.html',
  styleUrls: ['./inscripcion-home.component.scss'],
})
export class InscripcionHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
